import { render } from "./EmployeePayslips.vue?vue&type=template&id=60035d5c&scoped=true"
import script from "./EmployeePayslips.vue?vue&type=script&lang=js"
export * from "./EmployeePayslips.vue?vue&type=script&lang=js"

import "./EmployeePayslips.vue?vue&type=style&index=0&id=60035d5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60035d5c"]])

export default __exports__